<!--@if(!isDotNetInteroperable()) {
   @if(user()) {
   <app-internal-header [leadSection]="leadSection" class="flex-grow-0 flex-shrink-1 flex-basis-auto"></app-internal-header>
   }
   @else {
   <app-public-header></app-public-header>
   }
}-->

<section class="flex-grow-1 flex-shrink-0">
   <router-outlet></router-outlet>
</section>

<!--@if(!isDotNetInteroperable()) {
<app-site-footer class="flex-grow-0 flex-shrink-1"></app-site-footer>
}-->
